import '../profileSteps.scss';
import 'sass/blocks/_joint-holders.scss';
import 'sass/_OTPInput.scss';

import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { actions as formActions } from 'react-redux-form';
import cmsActions from 'actions/cmsActions';
import consentsActions from 'actions/consentsActions';
import createActions from 'actions/createActions';
import focusActions from 'actions/focusActions';
import ibanActions from 'actions/ibanActions';
import modalCancelActions from 'actions/modalCancelActions';
import optionsActions from 'actions/optionsActions';
import preLoaderActions from 'actions/preLoaderActions';
import standByActions from 'actions/standByActions';
import stepsActions from 'actions/stepsActions';
import { goToErrorsView } from 'actions/errorViewNavigation';
import { getReferenceCodeByCountry, disableNationalityByCountry } from 'utilities/multiLanguageHelper';
import { useNationalityField } from './hooks/useNationalityField';
import { useHandlers } from './hooks/useHandlers';
import { useValidations } from './hooks/useValidations';
import { FormBuilder } from './FormBuilder/FormBuilder';
import { JointHolder } from 'components/additional/jointHolder';
import { OtpView } from 'components/additional/otpView';
import { useInitProfileStep1OnMount } from './hooks/useInitProfileStep1OnMount';

const ProfileStep1Component = ({
    actions,
    cms,
    cmsActions,
    consentsActions,
    createActions,
    focus,
    focusActions,
    formActions,
    goToErrorsView,
    ibanActions,
    immStepsState,
    initialStep,
    modalCancelActions,
    options,
    optionsActions,
    preLoaderActions,
    scorings,
    userProfile,
    userProfileForm,
}) => {
    const { showJointHolder, showOTP } = userProfile;

    const { showModalCancel } = modalCancelActions;

    useNationalityField({
        disableNationalityByCountry,
        formActions,
        getReferenceCodeByCountry,
        options,
        optionsActions,
        userProfile,
    });

    const { formValidations } = useValidations({
        focus,
        focusActions,
        userProfileForm,
    });

    const {
        handleAddressUpdate,
        handleCancel,
        handleEnableSubmit,
        handleNextStep,
        handleSave,
        handleSubmit,
        isClicked,
        onHandleValidateFields,
    } = useHandlers({
        actions,
        consentsActions,
        createActions,
        focusActions,
        formActions,
        formValidations,
        goToErrorsView,
        ibanActions,
        immStepsState,
        options,
        preLoaderActions,
        scorings,
        showModalCancel,
        userProfile,
        userProfileForm,
    });

    useInitProfileStep1OnMount({ initialStep, cmsActions, preLoaderActions });

    const renderStep1Content = () => {
        if (showJointHolder) return <JointHolder />;

        if (showOTP) return <OtpView />;

        return (
            <FormBuilder
                cms={cms}
                handleAddressUpdate={handleAddressUpdate}
                handleCancel={handleCancel}
                handleEnableSubmit={handleEnableSubmit}
                handleNextStep={handleNextStep}
                handleSave={handleSave}
                handleSubmit={handleSubmit}
                isClicked={isClicked}
                onHandleValidateFields={onHandleValidateFields}
                options={options}
                scorings={scorings}
                userProfile={userProfile}
                userProfileForm={userProfileForm}
            />
        );
    };

    return <div className="basic-layering">{renderStep1Content()}</div>;
};

const mapStateToProps = state => ({
    userProfile: state.userProfile,
    extraData: state.extraData,
    userProfileForm: state.userProfileForm,
    immStepsState: state.steps,
    options: state.options,
    focus: state.focus,
    products: state.products,
    cms: state.cms,
    scorings: state.scorings,
    initialStep: state.initialStep,
});

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators(stepsActions, dispatch),
    formActions: bindActionCreators(formActions, dispatch),
    ibanActions: bindActionCreators(ibanActions, dispatch),
    optionsActions: bindActionCreators(optionsActions, dispatch),
    focusActions: bindActionCreators(focusActions, dispatch),
    standByActions: bindActionCreators(standByActions, dispatch),
    createActions: bindActionCreators(createActions, dispatch),
    cmsActions: bindActionCreators(cmsActions, dispatch),
    preLoaderActions: bindActionCreators(preLoaderActions, dispatch),
    modalCancelActions: bindActionCreators(modalCancelActions, dispatch),
    consentsActions: bindActionCreators(consentsActions, dispatch),
    goToErrorsView: bindActionCreators(goToErrorsView, dispatch),
});

export const ProfileStep1 = connect(mapStateToProps, mapDispatchToProps)(ProfileStep1Component);
